module.exports = __webpack_public_path__ + "static/media/additional-payment-methods.5985eb1c.svg";